<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">扣缴义务人管理</li>
      <el-button
        type="primary"
        :icon="Plus"
        link
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
        v-if="$judge_auth('64')"
        >添加</el-button
      >
    </ul>
    <ul class="c-list-search">
      <el-radio-group v-model="state.params.status" @change="onLoad">
        <el-radio-button>全部</el-radio-button>
        <el-radio-button :value="1">正常</el-radio-button>
        <el-radio-button :value="0">停用</el-radio-button>
      </el-radio-group>
      <el-input
        v-model="state.params.keywords"
        style="width: 200px"
        placeholder="名称、统一社会信用代码"
        clearable
        @clear="
          delete state.params.keywords;
          onLoad();
        "
        @paste.enter="$onKeywordsPaste($event, state.params)"
      ></el-input>
      <el-tree-select
        v-model="state.params.d_industry_id"
        :data="state.industryData"
        node-key="id"
        clearable
        accordion
        :props="{ label: 'name' }"
        :render-after-expand="false"
        :highlight-current="true"
        :default-expand-all="true"
        :check-strictly="true"
        placeholder="--所属行业--"
        @clear="delete state.params.d_industry_id"
        filterable
        style="width: 200px"
      >
        <template #default="{ data }">
          <div style="display: flex; align-items: center">
            {{ data.name }}
          </div>
        </template>
        <template #footer>
          <el-button size="small" @click="onLoadIndustry()">刷新</el-button>
        </template>
      </el-tree-select>
      <el-select
        v-model="state.params.tax_bureau_id"
        @clear="delete state.params.tax_bureau_id"
        style="width: 200px"
      >
        <el-option
          v-for="item in state.taxbureauData"
          :key="item"
          :label="item.name"
          :value="item.id"
        />
        <template #footer>
          <el-button size="small" @click="onLoadTaxBureauData()">
            刷新
          </el-button>
        </template>
      </el-select>
      <el-dropdown split-button @click="onLoad" type="primary">
        查询
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
              重置
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </ul>
    <ul class="c-list-table">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column
          label="状态/行业"
          sortable="status"
          :formatter="
            (row) =>
              $tab_GroupFormat(
                row.status == 0 ? '停用' : '正常',
                row.d_industry_name,
                row.status == 0 ? '#f00' : '#1e90ff'
              )
          "
          width="140"
        />
        <el-table-column label="局端状态" width="120">
          <template #default="{ row }">
            <text
              v-if="row.pts_password_status == 1 && row.pts_status == 1"
              style="color: #080"
              >注册成功</text
            >
            <div v-else style="display: flex; align-items: center">
              <text style="color: #f00">注册失败</text>
              <el-popover
                v-if="row.pts_msg || row.pts_password_msg"
                placement="right"
                trigger="hover"
              >
                <template #reference>
                  <el-icon
                    color="#ffa500"
                    style="margin-left: 5px; cursor: pointer"
                    ><QuestionFilled
                  /></el-icon>
                </template>
                <template #default>
                  <text
                    style="
                      font-size: 13px;
                      line-height: 22px;
                      color: #ffa500;
                      letter-spacing: 2px;
                    "
                    v-if="row.pts_msg"
                    >{{ row.pts_msg }}</text
                  >
                  <text
                    style="
                      font-size: 13px;
                      line-height: 22px;
                      color: #ffa500;
                      letter-spacing: 2px;
                    "
                    v-if="row.pts_password_msg"
                    >{{ row.pts_password_msg }}</text
                  >
                </template>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="企业名称"
          :formatter="$tab_TextFormat"
          :min-width="180"
        />
        <el-table-column
          prop="unified_social_credit_identifier"
          label="统一社会信用代码"
          width="200"
        >
          <template #default="{ row }">
            <text
              style="color: #1e90ff"
              class="text-hover-decoration"
              title="证件号"
              @click="$onCopy(row.unified_social_credit_identifier)"
            >
              {{ row.unified_social_credit_identifier }}
            </text>
          </template>
        </el-table-column>
        <el-table-column
          prop="tax_bureau_name"
          label="所属税局"
          :formatter="$tab_TextFormat"
          :min-width="180"
        />
        <el-table-column
          label="银行账户/户名"
          :formatter="
            (row) =>
              $tab_GroupFormat(row.bank_account || '-', row.bank_account_name)
          "
          :min-width="220"
        />
        <el-table-column
          prop="opening_bank"
          label="开户行"
          show-overflow-tooltip
          :formatter="$tab_TextFormat"
          :width="160"
        />
        <el-table-column
          prop="name"
          label="所在地址"
          :formatter="
            (row) =>
              $tab_GroupFormat(
                row.province + (row.city || '') + (row.district || ''),
                row.address || ''
              )
          "
          :min-width="220"
        />
        <el-table-column
          label="第三方协议"
          width="100"
          align="center"
          v-if="$judge_auth('598')"
        >
          <template #default="{ row }">
            <el-popover
              width="60%"
              trigger="click"
              @before-enter="onLoadChildren(row)"
            >
              <template #reference>
                <el-icon style="cursor: pointer"><View /></el-icon>
              </template>
              <template #default>
                <div style="display: flex; align-items: center">
                  <li style="display: flex; align-items: center; flex: 1">
                    <el-date-picker
                      v-model="state.skssq"
                      type="month"
                      format="YYYY年M月"
                      value-format="YYYYMM"
                      placeholder="税款所属期"
                      style="margin-right: 10px; width: 150px"
                      size="small"
                      :teleported="false"
                      :clearable="false"
                    />
                    <el-button
                      v-if="$judge_auth('599')"
                      icon="Refresh"
                      size="small"
                      @click="onUpdate(row)"
                      >更新</el-button
                    >
                  </li>
                  <el-button
                    type="primary"
                    icon="Refresh"
                    size="small"
                    @click="onLoadChildren(row, true)"
                    >刷新列表</el-button
                  >
                </div>
                <el-table
                  :data="row.children"
                  v-loading="!Array.isArray(row.children)"
                  element-loading-background="rgba(0, 0, 0, 0.2)"
                  style="margin-top: 10px"
                >
                  <el-table-column
                    prop="sfxyh"
                    label="三方协议号"
                    :formatter="$tab_TextFormat"
                    align="center"
                  />
                  <el-table-column
                    prop="yhhbmc"
                    label="开户银行"
                    :formatter="$tab_TextFormat"
                    align="center"
                  />
                  <el-table-column
                    prop="jkmc"
                    label="账户名称"
                    :formatter="$tab_TextFormat"
                    align="center"
                  />
                  <el-table-column
                    prop="jkzh"
                    label="缴款账户"
                    :formatter="$tab_TextFormat"
                    align="center"
                  />
                  <el-table-column
                    prop="is_default"
                    label="默认扣款账号"
                    align="center"
                  >
                    <template #default="{ row }">
                      <text
                        :style="{
                          color: row.is_default == 1 ? '#1e90ff' : '#f00',
                        }"
                        >{{ row.is_default == 1 ? "是" : "否" }}</text
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="200"
                    align="center"
                    fixed="right"
                    className="tabBtn"
                    v-if="$judge_auth('600')"
                  >
                    <template #default="scope">
                      <el-button
                        type="primary"
                        link
                        icon="Edit"
                        @click="onSetDefault(scope.row, row)"
                      >
                        设置为默认扣款账号
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="160"
          align="center"
          fixed="right"
          className="tabBtn"
          v-if="$judge_auth(['65', '66'])"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              icon="Edit"
              @click="
                state.selectId = row.id;
                state.showInfo = true;
              "
              v-if="$judge_auth('65')"
              :title="row.id"
            >
              编辑
            </el-button>
            <el-button
              type="danger"
              link
              icon="Delete"
              @click="onDelete(row.id)"
              v-if="$judge_auth('66')"
              :title="row.id"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showInfo"
        :title="(state.selectId ? '修改' : '添加') + '自营扣缴义务人'"
        @close="state.showInfo = false"
      >
        <c_WithholdingAgentInfo
          @close="
            state.showInfo = false;
            onLoad();
          "
          :id="state.selectId"
        ></c_WithholdingAgentInfo>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  withholdingagent_list,
  withholdingagent_delete,
  withholdingagent_other_list,
  withholdingagent_other_setdefault,
  withholdingagent_other_update,
} from "@/http/withholdingagent";
import { industry_tree } from "@/http/dictionary";
import { data_taxbureau_select } from "@/http/data";
import { confirm_func } from "@/utils/qFormat";
import { dayjs, ElMessage, ElMessageBox } from "element-plus";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_field: "create_time",
    sort_value: "desc",
  };
}
export default {
  setup() {
    const state = reactive(new InitFormData());
    onMounted(() => {
      onLoad();
      onLoadTaxBureauData();
      onLoadIndustry();

      setTimeout(() => {
        state.skssq = dayjs().format("YYYYMM");
      }, 1000);
    });

    const onLoad = () => {
      delete state.tableData;
      withholdingagent_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //获取税局
    const onLoadTaxBureauData = () => {
      data_taxbureau_select().then((res) => {
        if (res.status == 200) state.taxbureauData = res.data.data?.list;
      });
    };

    //获取行业树
    const onLoadIndustry = () => {
      industry_tree().then((res) => {
        if (res.status == 200) state.industryData = res.data.data;
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    //删除
    const onDelete = (id) => {
      confirm_func(withholdingagent_delete, id, onLoad);
    };

    const onLoadChildren = (row, ref) => {
      if (ref || !row.children) {
        delete row.children;
        withholdingagent_other_list(row.id).then((res) => {
          if (res.status == 200) row.children = res.data.data?.list;
        });
      }
    };

    const onSetDefault = (row, pRow) => {
      ElMessageBox.confirm(
        `您确定<strong style='color:#f00'>设置</strong>账户<strong style='color:#080'>${row.jkmc}</strong>为默认扣款账户吗？`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        withholdingagent_other_setdefault({ id: row.id }).then((res) => {
          if (res.status == 200) onLoadChildren(pRow, true);
        });
      });
    };

    const onUpdate = (row) => {
      ElMessageBox.confirm(
        `您确定<strong style='color:#f00'>更新</strong>扣缴义务人<strong style='color:#080'>${row.name}</strong>的第三方协议吗`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        withholdingagent_other_update({
          withholding_agent_id: row.id,
          skssq: state.skssq,
        }).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onLoadChildren(row, true);
          }
        });
      });
    };
    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      onLoadTaxBureauData,
      onLoadIndustry,
      onDelete,
      onLoadChildren,
      onSetDefault,
      onUpdate,
    };
  },
};
</script>
<style scoped></style>
